export default __webpack_public_path__ + "static/media/hosting.5165120a.jpg";